import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-469f9517"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sales-ratio-form-hint-banner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "64 64 896 896",
  width: "16",
  height: "16",
  fill: "#d48806",
  class: "hint-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hint-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "温馨提示："),
  /*#__PURE__*/_createTextVNode("当不同维度的政策发生重叠时，系统将严格按照 "),
  /*#__PURE__*/_createElementVNode("strong", null, "客户 > 省区 > 渠道"),
  /*#__PURE__*/_createTextVNode(" 的优先级生效，请注意检查包含关系。 ")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}